module.exports = __webpack_public_path__ + "img/ermj.3e91456b.jpg";